import React from 'react';
import PropTypes from 'prop-types';
import Modal from './Modal';

const EnhancedNotice = props => {
    return (
        <Modal onClose={props.onClose}>
            <div className="syos-enhanced-notice">
                <div className="syos-enhanced-notice__inner">
                    <h3 className="syos-enhanced-notice__title">{props.notice.title}</h3>
                    <div className="syos-enhanced-notice__message">{props.notice.content()}</div>
                    <div className="syos-enhanced-notice__actions">
                        <button className="syos-button"
                            onClick={props.notice.actionFn}>
                            {props.notice.actionLabel}
                        </button>
                    </div>
                </div>
            </div>
        </Modal>
    )
};

EnhancedNotice.propTypes = {
    notice: PropTypes.object,
    onClose: PropTypes.func.isRequired
};

export default EnhancedNotice;



// WEBPACK FOOTER //
// ./src/javascripts/app/components/EnhancedNotice.js